var _rect, _rect2, _path, _path2, _path3, _rect3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneSim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-63b4bbef-2649-4d1a-9282-7959ffdc88eb",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 432.52 963.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 432.52,
    height: 963.4,
    rx: 32.86,
    ry: 32.86
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.9,
    y: 25.42,
    width: 408.72,
    height: 912.56,
    rx: 29.21,
    ry: 29.21,
    style: {
      fill: "#00b14c"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 350.34,
    y: 898.42,
    width: 24.86,
    height: 24.86,
    rx: 2.74,
    ry: 2.74
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m215.44,898.42h0c6.86,0,12.43,5.57,12.43,12.43h0c0,6.86-5.57,12.43-12.43,12.43h0c-6.86,0-12.43-5.57-12.43-12.43h0c0-6.86,5.57-12.43,12.43-12.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m58.95,913.68l15.07,8.7c2.18,1.26,4.9-.31,4.9-2.83v-17.4c0-2.51-2.72-4.08-4.9-2.83l-15.07,8.7c-2.18,1.26-2.18,4.4,0,5.65h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m280.09,650.91c4.1,0,7.43,3.33,7.43,7.43v25.34c0,4.1-3.33,7.43-7.43,7.43h-25.34c-4.1,0-7.43-3.33-7.43-7.43v-25.34c0-4.1,3.33-7.43,7.43-7.43h25.34m0-5h-25.34c-6.84,0-12.43,5.59-12.43,12.43v25.34c0,6.84,5.59,12.43,12.43,12.43h25.34c6.84,0,12.43-5.59,12.43-12.43v-25.34c0-6.84-5.59-12.43-12.43-12.43h0Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 336.66,
    y: 645.91,
    width: 50.2,
    height: 50.2,
    rx: 12.43,
    ry: 12.43
  })), /*#__PURE__*/React.createElement("path", {
    d: "m70.26,645.91h0c13.86,0,25.1,11.24,25.1,25.1h0c0,13.86-11.24,25.1-25.1,25.1h0c-13.86,0-25.1-11.24-25.1-25.1h0c0-13.86,11.24-25.1,25.1-25.1Z",
    style: {
      fill: "#fff"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m167.59,645.91h0c13.86,0,25.1,11.24,25.1,25.1h0c0,13.86-11.24,25.1-25.1,25.1h0c-13.86,0-25.1-11.24-25.1-25.1h0c0-13.86,11.24-25.1,25.1-25.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m82.93,545.91c4.1,0,7.43,3.33,7.43,7.43v25.34c0,4.1-3.33,7.43-7.43,7.43h-25.34c-4.1,0-7.43-3.33-7.43-7.43v-25.34c0-4.1,3.33-7.43,7.43-7.43h25.34m0-5h-25.34c-6.84,0-12.43,5.59-12.43,12.43v25.34c0,6.84,5.59,12.43,12.43,12.43h25.34c6.84,0,12.43-5.59,12.43-12.43v-25.34c0-6.84-5.59-12.43-12.43-12.43h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.49,
    y: 540.91,
    width: 50.2,
    height: 50.2,
    rx: 12.43,
    ry: 12.43,
    style: {
      fill: "#fff"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m180.09,545.91c4.1,0,7.43,3.33,7.43,7.43v25.34c0,4.1-3.33,7.43-7.43,7.43h-25.34c-4.1,0-7.43-3.33-7.43-7.43v-25.34c0-4.1,3.33-7.43,7.43-7.43h25.34m0-5h-25.34c-6.84,0-12.43,5.59-12.43,12.43v25.34c0,6.84,5.59,12.43,12.43,12.43h25.34c6.84,0,12.43-5.59,12.43-12.43v-25.34c0-6.84-5.59-12.43-12.43-12.43h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m361.76,545.91c11.08,0,20.1,9.02,20.1,20.1s-9.02,20.1-20.1,20.1-20.1-9.02-20.1-20.1,9.02-20.1,20.1-20.1m0-5c-13.8,0-25.1,11.29-25.1,25.1s11.29,25.1,25.1,25.1,25.1-11.29,25.1-25.1-11.29-25.1-25.1-25.1h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.65,786.9c11.08,0,20.1,9.02,20.1,20.1s-9.02,20.1-20.1,20.1H59.87c-11.08,0-20.1-9.02-20.1-20.1s9.02-20.1,20.1-20.1h312.78m0-5H59.87c-13.8,0-25.1,11.29-25.1,25.1s11.29,25.1,25.1,25.1h312.78c13.8,0,25.1-11.29,25.1-25.1s-11.29-25.1-25.1-25.1h0Z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSim);
export default __webpack_public_path__ + "static/media/phoneSim.ca032c17ce32b46aa8791c54a04296d9.svg";
export { ForwardRef as ReactComponent };